export const inputPadding = {
  px: 3,
  py: 2
}

export const mdInputPadding = {
  px: 2,
  py: 2
}

export const smInputPadding = {
  px: 1,
  py: 1
}
